var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"self-registration__bg d-flex justify-center align-center"},[_c('div',{style:(`width: ${_vm.responsive_width('', '90vw', '75vw', '50vw', '40vw')}`)},[(_vm.pre_auth_component)?_c(_vm.pre_auth_component,{tag:"component"}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }